import http from '@utils/http';


  // 获取视频详情
export function getVideoDetail(id) {
  return http
    .get(`/workscene/workscene/v1/learning_garden/${id}`)
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

  // 播放量增加
export function putPlayNum(id) {
  return http
      .put(`/workscene/workscene/v1/learning_garden/play/${id}`)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
}